import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";

const PrivateRoute = ({ component: Component, extraProps, ...rest }) => {
  const isLogged = useSelector((state) => state.auth.isLogged);
  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /signin page
    <Route
      {...rest}
      render={(props) =>
        isLogged ? <Component {...extraProps} {...props} /> : <Redirect to="/login" />
      }
    />
  );
};

export default PrivateRoute;
